import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/SEOHead';

export default function SitemapPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Sitemap',
    description: 'Complete sitemap of Fresno Electrical Services website',
    url: `${siteUrl}/sitemap`
  };

  const mainPages = [
    { name: 'Home', path: '/' },
    { name: 'Contact', path: '/contact' }
  ];

  const servicePages = [
    { name: 'Residential Electrical Services', path: '/services/residential-electrical' },
    { name: 'Commercial Electrical Specialist', path: '/services/commercial-specialist' },
    { name: 'Smart Home & Energy Management', path: '/services/smart-home-energy' },
    { name: 'Lighting Design & Outdoor Lighting', path: '/services/lighting-outdoor' },
    { name: 'Renewables & EV Charging', path: '/services/renewables-ev' },
    { name: 'Electrical Testing & Certification', path: '/services/testing-certification' },
    { name: 'Fire Safety & Alarm Systems', path: '/services/fire-safety' },
    { name: 'Repairs & Maintenance', path: '/services/repairs-maintenance' }
  ];

  const legalPages = [
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms of Service', path: '/terms' }
  ];

  return (
    <>
      <SEOHead
        title="Sitemap | Fresno Electrical Services"
        description="Complete sitemap of Fresno Electrical Services. Find all pages including residential, commercial, and emergency electrical services in Fresno, CA."
        canonical="/sitemap"
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        
        {/* Hero */}
        <div className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20 border-t-4 border-yellow-500">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/f2e930c7e8c746a140da8d4fa220c446.jpg')] opacity-5 bg-cover bg-center"></div>
          <div className="container mx-auto px-6 relative z-10">
            <h1 className="text-5xl font-bold mb-4">Sitemap</h1>
            <p className="text-xl text-gray-300">Navigate all pages of Electrician Solutions Fresno</p>
          </div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-6 py-16 max-w-6xl">
          
          {/* Main Pages */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-3 border-b-2 border-yellow-500">Main Pages</h2>
            <div className="grid md:grid-cols-2 gap-4">
              {mainPages.map((page) => (
                <Link
                  key={page.path}
                  to={page.path}
                  className="group flex items-center gap-3 p-4 bg-gray-50 hover:bg-yellow-50 rounded-lg transition-all duration-300 border border-gray-200 hover:border-yellow-500"
                >
                  <i className="ri-arrow-right-s-line text-2xl text-yellow-500 group-hover:translate-x-1 transition-transform"></i>
                  <span className="text-lg text-gray-800 group-hover:text-gray-900 font-medium">{page.name}</span>
                </Link>
              ))}
            </div>
          </section>

          {/* Service Pages */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-3 border-b-2 border-yellow-500">Our Services</h2>
            <div className="grid md:grid-cols-2 gap-4">
              {servicePages.map((page) => (
                <Link
                  key={page.path}
                  to={page.path}
                  className="group flex items-center gap-3 p-4 bg-gray-50 hover:bg-yellow-50 rounded-lg transition-all duration-300 border border-gray-200 hover:border-yellow-500"
                >
                  <i className="ri-flashlight-line text-2xl text-yellow-500 group-hover:scale-110 transition-transform"></i>
                  <span className="text-lg text-gray-800 group-hover:text-gray-900 font-medium">{page.name}</span>
                </Link>
              ))}
            </div>
          </section>

          {/* Legal Pages */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 pb-3 border-b-2 border-yellow-500">Legal & Policies</h2>
            <div className="grid md:grid-cols-2 gap-4">
              {legalPages.map((page) => (
                <Link
                  key={page.path}
                  to={page.path}
                  className="group flex items-center gap-3 p-4 bg-gray-50 hover:bg-yellow-50 rounded-lg transition-all duration-300 border border-gray-200 hover:border-yellow-500"
                >
                  <i className="ri-file-text-line text-2xl text-yellow-500 group-hover:scale-110 transition-transform"></i>
                  <span className="text-lg text-gray-800 group-hover:text-gray-900 font-medium">{page.name}</span>
                </Link>
              ))}
            </div>
          </section>

          {/* Quick Contact */}
          <section className="bg-gradient-to-br from-gray-900 to-black text-white p-8 rounded-lg border-t-4 border-yellow-500">
            <h2 className="text-2xl font-bold mb-4">Need Help Finding Something?</h2>
            <p className="text-gray-300 mb-6">
              Can't find what you're looking for? Contact us directly and we'll be happy to assist you.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="tel:+15595551234"
                className="inline-flex items-center gap-2 px-6 py-3 bg-yellow-500 text-black font-semibold rounded-lg hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Call (559) 555-1234
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line text-xl"></i>
                Contact Us
              </Link>
            </div>
          </section>

        </div>

        <Footer />
      </div>
    </>
  );
}
